<div class="top-search">
  <div id="request_table_filter" class="form-group">
    <img src="assets/images/svg/search-icon.svg" alt="">
    <input type="search" #searchInput class="form-control input-sm search-query ml-2" id="search_query" [placeholder]="placeholder"
      aria-controls="request-table" (input)="handleEmptyValue()" (keydown.enter)="doSearch()"/>
      <button [disabled]="!searchInput.value" class="btn btn-success" (click)="doSearch()">بحث</button>
  </div>
</div>
